/** Client-side mirror of common registry rules for instant re-suggest in template studio.
 * Returns null when unknown — never invent a dynamic_field key.
 */
const CANONICAL_RULES = {
  'applicant.name': { target_type: 'application_column', target_path: 'Application.name' },
  'applicant.aadhar': { target_type: 'application_column', target_path: 'Application.aadhar' },
  'applicant.pan': { target_type: 'application_column', target_path: 'Application.pan' },
  'applicant.address': { target_type: 'application_column', target_path: 'Application.address' },
  'applicant.mobile': { target_type: 'application_column', target_path: 'Application.mobile' },
  'applicant.email': { target_type: 'application_column', target_path: 'Application.email' },
  'applicant.dob': { target_type: 'application_column', target_path: 'Application.dob' },
  'company.gst': { target_type: 'dynamic_field', target_path: 'company_gst' },
  'company.pan': { target_type: 'dynamic_field', target_path: 'company_pan' },
  'company.name': { target_type: 'dynamic_field', target_path: 'company_name' },
  'company.address': { target_type: 'dynamic_field', target_path: 'company_address' },
  'company.email': { target_type: 'dynamic_field', target_path: 'company_email' },
  'company.mobile': { target_type: 'dynamic_field', target_path: 'company_number' },
  'unit.block': { target_type: 'dynamic_field', target_path: 'block_name' },
  'unit.name': { target_type: 'dynamic_field', target_path: 'unit_name' },
  'unit.price.base': { target_type: 'computed', target_path: 'unit.price.base' },
  'unit.gst_percent': { target_type: 'computed', target_path: 'unit.gst_percent' },
  'project.name': { target_type: 'dynamic_field', target_path: 'project_name' },
  project_name: { target_type: 'dynamic_field', target_path: 'project_name' },
  'land.address': { target_type: 'dynamic_field', target_path: 'land_address' },
  'land.name': { target_type: 'dynamic_field', target_path: 'land_name' },
  date: { target_type: 'dynamic_field', target_path: 'date' },
  'table.pricing': { target_type: 'computed', target_path: 'table.pricing' },
  'table.salient_features': {
    target_type: 'computed',
    target_path: 'table.salient_features'
  },
  'sale.gst_amount': { target_type: 'computed', target_path: 'sale.gst_amount' },
  'sale.total': { target_type: 'computed', target_path: 'sale.total' },
  'sale.total.words': { target_type: 'computed', target_path: 'sale.total.words' },
  'sale.base.words': { target_type: 'computed', target_path: 'sale.base.words' },
  building_rera_registration_no: {
    target_type: 'dynamic_field',
    target_path: 'building_rera_registration_no'
  },
  accomodation_carpetarea: {
    target_type: 'dynamic_field',
    target_path: 'accomodation_carpetarea'
  },
  accomodation_builduparea: {
    target_type: 'dynamic_field',
    target_path: 'accomodation_builduparea'
  },
  accomodation_name: {
    target_type: 'dynamic_field',
    target_path: 'accomodation_name'
  },
  'accommodation.tag': {
    target_type: 'dynamic_field',
    target_path: 'accomodation_name'
  },
  'accommodation.name': {
    target_type: 'dynamic_field',
    target_path: 'accomodation_name'
  },
  'registration.rera_number': {
    target_type: 'dynamic_field',
    target_path: 'building_rera_registration_no'
  },
  'registration.rera_date': {
    target_type: 'dynamic_field',
    target_path: 'building_rera_approval_date'
  },
  'registration.rera_authority': {
    target_type: 'computed',
    target_path: 'registration.rera_authority'
  },
  'commencement_certificate.letter_number': {
    target_type: 'dynamic_field',
    target_path: 'building_permission_no'
  },
  'commencement_certificate.date': {
    target_type: 'dynamic_field',
    target_path: 'building_permission_date'
  },
  'commencement_certificate.issuing_authority': {
    target_type: 'computed',
    target_path: 'commencement_certificate.issuing_authority'
  },
  'layout_approval.letter_number': {
    target_type: 'dynamic_field',
    target_path: 'project_tncp_registration_number'
  },
  'layout_approval.date': {
    target_type: 'dynamic_field',
    target_path: 'project_tncp_registration_date'
  },
  'layout_approval.issuing_authority': {
    target_type: 'computed',
    target_path: 'layout_approval.issuing_authority'
  },
  'apartment_ownership_act.name': {
    target_type: 'computed',
    target_path: 'apartment_ownership_act.name'
  },
  'possession.date': { target_type: 'computed', target_path: 'possession.date' },
  'execution.city': { target_type: 'computed', target_path: 'execution.city' },
  'execution.date': { target_type: 'computed', target_path: 'execution.date' },
  'execution.sub_registrar_office': {
    target_type: 'computed',
    target_path: 'execution.sub_registrar_office'
  },
  'payment.payable_city': {
    target_type: 'computed',
    target_path: 'payment.payable_city'
  },
  'payment.penalty_interest_rate': {
    target_type: 'computed',
    target_path: 'payment.penalty_interest_rate'
  },
  'promoter.signatory_name': {
    target_type: 'computed',
    target_path: 'promoter.signatory_name'
  },
  'promoter.signatory_address': {
    target_type: 'dynamic_field',
    target_path: 'company_address'
  },
  'project.city': { target_type: 'computed', target_path: 'project.city' },
  'unit.carpet_area': {
    target_type: 'dynamic_field',
    target_path: 'accomodation_carpetarea'
  },
  'unit.built_up_area': {
    target_type: 'dynamic_field',
    target_path: 'accomodation_builduparea'
  },
  'unit.plot_area': {
    target_type: 'dynamic_field',
    target_path: 'accomodation_plotarea'
  },
  'unit.typology': { target_type: 'computed', target_path: 'unit.typology' },
  'unit.type': { target_type: 'computed', target_path: 'unit.typology' },
  'unit.facing': { target_type: 'computed', target_path: 'unit.facing' },
  'unit.undivided_land_share': {
    target_type: 'computed',
    target_path: 'unit.undivided_land_share'
  },
  'unit.accommodation_type': {
    target_type: 'dynamic_field',
    target_path: 'accomodation_name'
  },
  'payment.booking_amount': {
    target_type: 'computed',
    target_path: 'payment.booking_amount'
  },
  'payment.booking_amount.words': {
    target_type: 'computed',
    target_path: 'payment.booking_amount.words'
  },
  'payment.cheque_number': {
    target_type: 'computed',
    target_path: 'payment.cheque_number'
  },
  'amenities.temple_completion_date': {
    target_type: 'computed',
    target_path: 'amenities.temple_completion_date'
  },
  'amenities.gardens_completion_date': {
    target_type: 'computed',
    target_path: 'amenities.gardens_completion_date'
  },
  'amenities.clubhouse_completion_date': {
    target_type: 'computed',
    target_path: 'amenities.clubhouse_completion_date'
  },
  'amenities.pool_completion_date': {
    target_type: 'computed',
    target_path: 'amenities.pool_completion_date'
  },
  'amenities.podium_garden_completion_date': {
    target_type: 'computed',
    target_path: 'amenities.podium_garden_completion_date'
  },
  'applicant.title': { target_type: 'computed', target_path: 'applicant.title' },
  'applicant.relation_prefix': {
    target_type: 'computed',
    target_path: 'applicant.relation_prefix'
  },
  'applicant.relationship_name': {
    target_type: 'application_column',
    target_path: 'Application.relationshipName'
  },
  'applicant.relation_line': {
    target_type: 'computed',
    target_path: 'applicant.relation_line'
  }
};

/** Citihaus-style allotment letter tokens → HousinGram canonical merge keys. */
const ALLOTMENT_LETTER_ALIASES = {
  applicant_name: 'applicant.name',
  co_applicant_name: 'applicant.2.name',
  applicant_address: 'applicant.address',
  unit_no: 'unit.name',
  project_name: 'project.name',
  project_location: 'project.city',
  bungalow_type: 'unit.typology',
  builtup_area: 'unit.built_up_area',
  carpet_area: 'unit.carpet_area',
  attached_plot_area: 'unit.plot_area',
  facing: 'unit.facing',
  basic_sale_price: 'unit.price.base',
  gst_amount: 'sale.gst_amount',
  total_sale_value: 'sale.total',
  amount_received: 'payment.booking_amount',
  application_date: 'date',
  allotment_date: 'date'
};

export function suggestMappingForPlaceholder(name) {
  const normalized = (name || '')
    .trim()
    .toLowerCase()
    // DOCX sometimes splits tokens: "Infrastructure  Development_Charges"
    .replace(/\s+/g, ' ')
    .replace(/ /g, '_');
  if (!normalized) return null;

  if (/^structural\.|^landowner\./.test(normalized)) {
    return null;
  }

  if (CANONICAL_RULES[normalized]) {
    return { placeholder_name: name, ...CANONICAL_RULES[normalized] };
  }

  const aliasCanonical = ALLOTMENT_LETTER_ALIASES[normalized];
  if (aliasCanonical && CANONICAL_RULES[aliasCanonical]) {
    return { placeholder_name: name, ...CANONICAL_RULES[aliasCanonical] };
  }
  if (aliasCanonical) {
    // Computed / application paths not always in CANONICAL_RULES under dotted form
    const applicantMatch = aliasCanonical.match(/^applicant(?:\.(\d+))?\.([a-z_]+)$/);
    if (applicantMatch) {
      const applicantNumber = applicantMatch[1]
        ? parseInt(applicantMatch[1], 10)
        : 1;
      const column = applicantMatch[2];
      const columnMap = {
        name: 'Application.name',
        address: 'Application.address',
        aadhar: 'Application.aadhar',
        pan: 'Application.pan',
        mobile: 'Application.mobile',
        email: 'Application.email',
        dob: 'Application.dob'
      };
      if (columnMap[column]) {
        return {
          placeholder_name: name,
          target_type: 'application_column',
          target_path: columnMap[column],
          applicant_number: applicantNumber
        };
      }
    }
    return {
      placeholder_name: name,
      target_type: 'computed',
      target_path: aliasCanonical
    };
  }

  // Amenity schedule defaults to project possession (filled at merge time)
  if (/^amenities\.[a-z0-9_]+_completion_date$/.test(normalized)) {
    return {
      placeholder_name: name,
      target_type: 'computed',
      target_path: normalized
    };
  }

  if (
    /^applicant(?:\.\d+)?\.(?:title|relation_prefix|relation_line)$/.test(
      normalized
    )
  ) {
    return {
      placeholder_name: name,
      target_type: 'computed',
      target_path: normalized
    };
  }

  const applicantMatch = normalized.match(/^applicant(?:\.(\d+))?\.([a-z_]+)$/);
  if (applicantMatch) {
    const applicantNumber = applicantMatch[1] ? parseInt(applicantMatch[1], 10) : 1;
    const column = applicantMatch[2];
    const columnMap = {
      name: 'Application.name',
      aadhar: 'Application.aadhar',
      pan: 'Application.pan',
      address: 'Application.address',
      mobile: 'Application.mobile',
      email: 'Application.email',
      dob: 'Application.dob',
      relationship: 'Application.relationship',
      relationship_name: 'Application.relationshipName',
      relationshipname: 'Application.relationshipName'
    };
    if (columnMap[column]) {
      return {
        placeholder_name: name,
        target_type: 'application_column',
        target_path: columnMap[column],
        applicant_number: applicantNumber
      };
    }
  }

  return null;
}

/** Human label for application_column mapping that includes co-applicant row. */
export function describeApplicationMapping(placeholderName, targetPath) {
  const match = (placeholderName || '')
    .trim()
    .toLowerCase()
    .match(/^applicant(?:\.(\d+))?\.([a-z_]+)$/);
  if (!match) return targetPath || '';
  const n = match[1] ? parseInt(match[1], 10) : 1;
  const column = match[2];
  if (n >= 2) {
    return `Application #${n} · ${column} (co-applicant row)`;
  }
  return `Application #1 · ${column} (primary)`;
}
